var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertWhiteFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.9999C23.732 29.9999 30 23.7319 30 15.9999C30 8.26789 23.732 1.99988 16 1.99988C8.26801 1.99988 2 8.26789 2 15.9999C2 23.7319 8.26801 29.9999 16 29.9999Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C16.4142 24 16.75 23.6642 16.75 23.25C16.75 22.8358 16.4142 22.5 16 22.5C15.5858 22.5 15.25 22.8358 15.25 23.25C15.25 23.6642 15.5858 24 16 24Z",
    fill: "#52583C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 7.99988,
    width: 1,
    height: 12,
    rx: 0.5,
    fill: "#52583C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWhiteFilled);
export default __webpack_public_path__ + "static/media/alert-white-filled.af55af88a0539ad48e414b1dee389bc8.svg";
export { ForwardRef as ReactComponent };